export default {
  id: null,
  companyID: null,
  insuranceID: null,
  stageID: null,
  responsibleID: null,
  regulationTypeID: null,
  businessTypeID: null,
  budgetSystemID: null,
  mechanicalWorkshopID: null,
  insuredID: null,
  conductorID: null,
  thirdID: null,
  sinisterCode: null,
  sinisterVersion: null,
  sinisterDate: null,
  receiptDate: null,
  budgetNumber: null,
  autoModelID: null,
  autoTypeID: null,
  brandID: null,
  autoboard: null,
  chassis: null,
  plate: null,
  year: null,
  color: null,
  seem: null,
  damageClaimed: null,
  description: null,
  schedulingTypeID: null,
  productID: null
}



// WEBPACK FOOTER //
// ./src/shared/models/regulation/auto/sinisterdetailsmodel.js